function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * Jump.js 1.0.1 - A small, modern, dependency-free smooth scrolling library.
 * Copyright (c) 2016 Michael Cavalea - https://github.com/callmecavs/jump.js
 * License: MIT
 */
!function (o, n) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define(n) : o.Jump = n();
}(this, function () {
  "use strict";

  var o = function o(_o, n, e, t) {
    return _o /= t / 2, _o < 1 ? e / 2 * _o * _o + n : (_o--, -e / 2 * (_o * (_o - 2) - 1) + n);
  },
      n = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (o) {
    return _typeof(o);
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol ? "symbol" : _typeof(o);
  },
      e = function e() {
    function e() {
      return window.scrollY || window.pageYOffset;
    }

    function t(o) {
      return o.getBoundingClientRect().top + d;
    }

    function i(o) {
      v || (v = o), b = o - v, p = s(b, d, y, m), window.scrollTo(0, p), b < m ? requestAnimationFrame(i) : r();
    }

    function r() {
      window.scrollTo(0, d + y), c && l && (c.setAttribute("tabindex", "-1"), c.focus()), "function" == typeof w && w(), v = !1;
    }

    function u(r) {
      var u = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1];

      switch (m = u.duration || 1e3, a = u.offset || 0, w = u.callback, s = u.easing || o, l = u.a11y || !1, d = e(), "undefined" == typeof r ? "undefined" : n(r)) {
        case "number":
          c = void 0, l = !1, f = d + r;
          break;

        case "object":
          c = r, f = t(c);
          break;

        case "string":
          c = document.querySelector(r), f = t(c);
      }

      switch (y = f - d + a, n(u.duration)) {
        case "number":
          m = u.duration;
          break;

        case "function":
          m = u.duration(y);
      }

      requestAnimationFrame(i);
    }

    var c = void 0,
        d = void 0,
        f = void 0,
        a = void 0,
        s = void 0,
        l = void 0,
        y = void 0,
        m = void 0,
        v = void 0,
        b = void 0,
        p = void 0,
        w = void 0;
    return u;
  },
      t = e();

  return t;
});